import { createAuthClient } from 'better-auth/react'
import { API_URL } from '@/config'

const baseURL = API_URL.startsWith('/')
	? `${window.location.origin}${API_URL}`
	: API_URL

export const authClient = createAuthClient({
	baseURL: baseURL || undefined,
})

export const { signIn, signUp, signOut, useSession, getSession } = authClient
